import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DraggableManualMatcher from '../../../../../components/draggablemanualmatcher/DraggableManualMatcher';
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import Loadable from '../../../../../components/loadable/Loadable';
import { getFieldsForMatching } from '../../BatchImportSaga';
import { componentKey as batchImportComponentKey, setDraggableFormBoxes, setMappedFields, updateBatchImportFormData } from '../../BatchImportSlice';
import { BATCH_FORMS_LOADING_STATES, BATCH_FORM_STATES_MESSAGE_MAP } from '../../constants';

export default function MatchFields({}) {

    const dispatch = useDispatch();
    const {loadingState, excelFields, formFields, batchImportFormData, draggableFormBoxes, mappedFields, formSettings} = useSelector(state => state[batchImportComponentKey]);

    useEffect(() => {
        if(formFields.length > 0){
            dispatch(setDraggableFormBoxes(formFields));
        }
    }, [formFields]);

    useEffect(() => {
        if(excelFields.length > 0){
            dispatch(setMappedFields(excelFields));
        }
    }, [excelFields]);

    useEffect(() => {
        if(batchImportFormData?.selectedForm?.FormId !== null && batchImportFormData.isUploadedDataSessionSet && formSettings?.showMappingPageFlag ){
            dispatch(getFieldsForMatching({formId: batchImportFormData.selectedForm.FormId, year: batchImportFormData?.selectedYear ?? null}));
            dispatch(updateBatchImportFormData({isUploadedDataSessionSet: null}));
        }
    }, [batchImportFormData.isUploadedDataSessionSet])

    return <>
        <Heading type={HEADING.H2}>
            Please map relevant {batchImportFormData?.selectedForm?.FormId} boxes to the columns from Excel
        </Heading>
        <Loadable
            currentState={loadingState.state} 
            loadingStates={[BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_LOADING]} 
            messageMap={BATCH_FORM_STATES_MESSAGE_MAP}
            isNewLoadable={true}
        >
            <DraggableManualMatcher formTitle={batchImportFormData?.selectedForm?.FormId} thirdPartyTitle={"Excel"} draggableFormBoxes={draggableFormBoxes} mappedFields={mappedFields} setDraggableFormBoxesCb={(updatedBoxes) => dispatch(setDraggableFormBoxes(updatedBoxes))} setMappedFieldsCb={(updatedMappedFields) => dispatch(setMappedFields(updatedMappedFields))} />
        </Loadable>
    </>
}